import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class FlowActionResource extends BaseResource {
    pk() {
        return "_";
    }
}
FlowActionResource.urlRoot = legacyApiResourceUrl("Admin/FlowTest/Flows");
//# sourceMappingURL=FlowActionResource.js.map